<template>
	<div class="my_home">
		<!--我的信息-->
		<div class="my_info" @click="$router.push('/my/account')">
			<div class="avatar">
				<img v-if="wechatInfo.headimg" :src="wechatInfo.headimg" alt="" />
				<img v-else src="@/assets/img/default_avatar.png" alt="" />
			</div>
			<div class="info">
				<div class="user_name">{{ wechatInfo.nickname || wechatInfo.phone }}</div>
				<div class="action">
					<img src="@/assets/icon/icon_arrow_default.png" alt="" />
				</div>
			</div>
		</div>
		<!--患者列表-->

		<div class="patient_list mt-40 bg-white">
			<!-- <div class="patient_tab-title">患者档案</div> -->
			<van-tabs v-model="curSelectPatientIndex" animated :ellipsis="false">
				<van-tab v-for="(item) in patientList" :key="item.id" :title="item.name">
					<div class="handle_content">
						<van-row gutter="35">
							<van-col :span="6" @click="$router.push(`/health/base/${item.id}`)">
								<div class="list_icon">
									<img src="@/assets/icon/icon_my_home_1.png" alt="" />
								</div>
								<span class="list_text">基本信息</span>
							</van-col>
							<van-col :span="6" @click="showDoctorOrTeam(item)">
								<div class="list_icon">
									<img src="@/assets/icon/icon_my_home_2.png" alt="" />
								</div>
								<span class="list_text">{{item.bindType === 1?'医生信息':'团队信息'   }}</span>
							</van-col>
							<!-- <van-col :span="6" @click="$router.push(`/physicianVisits/record/${item.id}`)">
								<div class="list_icon">
									<img src="@/assets/icon/icon_my_home_3.png" alt="" />
								</div>
								<span class="list_text">服务记录</span>
							</van-col> -->
							<van-col :span="6" @click="$router.push(`/order/record/${item.id}`)">
								<div class="list_icon">
									<img src="@/assets/icon/icon_my_home_3.png" alt="" />
								</div>
								<span class="list_text">订单记录</span>
							</van-col>
							<van-col :span="6"></van-col>
						</van-row>
					</div>
				</van-tab>
			</van-tabs>
		</div>
		<!--菜单列表-->
		<div class="menu_list mt-28">
			<van-cell-group>
				<van-cell title="咨询订单" is-link @click="$router.push('/order/chat')">
					<template #icon>
						<img class="menu_list_icon" src="@/assets/icon/icon_my_home_8.png" alt="" />
					</template>
				</van-cell>
				<!-- <van-cell title="我的医生" is-link @click="$router.push('/order/record')">
					<template #icon>
						<img class="menu_list_icon" src="@/assets/icon/icon_my_home_10.png" alt="" />
					</template>
				</van-cell> -->
				<van-cell title="绑定家属" is-link @click="$router.push('/jointManage/list')">
					<template #icon>
						<img class="menu_list_icon" src="@/assets/icon/icon_my_home_5.png" alt="" />
					</template>
				</van-cell>
				<!-- <van-cell title="地址管理" is-link @click="jumpAdress">
					<template #icon>
						<img class="menu_list_icon" src="@/assets/icon/icon_my_home_9.png" alt="" />
					</template>
				</van-cell> -->
			</van-cell-group>
		</div>
		<!-- 团队详情弹窗 -->
		<DepartmentDetailDialog v-model="showTeamDetail" :item="teamDetail" :goMain="false" />
		<!-- 医生详情弹窗 -->
		<DoctorDetailDialog v-model="showDoctorDetail" :item="doctor" :goMain="false" />
	</div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import DoctorDetailDialog from '../dpbind/components/doctor-detail-dialog.vue'
import DepartmentDetailDialog from '../physician-visits/components/department-detail-dialog.vue'
export default {
    name: 'MyHome',
    components: { DoctorDetailDialog, DepartmentDetailDialog },
    data: () => ({
        wechatInfo: {},
        patientList: [],
        teamDetail: {},
        doctor: {},
        showTeamDetail: false,
        showDoctorDetail: false,
    }),
    computed: {
        ...mapGetters('account', ['getMyPagePatientId']),
        curSelectPatientIndex: {
            get () {
                return this.getMyPagePatientId
            },
            set (val) {
                this.SET_MY_PAGE_PATIENT_ID(val)
            }
        }

    },
    // activated(){
    // 	if(this.wechatInfo.nickname){
    // 		this.load ()
    // 	}	
    // },
    created () {
        this.load()
    },
    methods: {
        ...mapMutations('account', ['SET_MY_PAGE_PATIENT_ID']),
        load () {
            this.$http.all({
                wechatInfo: this.$api.account.getWechatInfo(),
                patientList: this.$api.patient.getPatientList()
            }, res => {
                if (!res.wechatInfo.code) {
                    this.wechatInfo = res.wechatInfo.data
                }
                if (!res.patientList.code) {
                    this.patientList = res.patientList.data
                    if (!this.curSelectPatientIndex) {
                        this.curSelectPatientIndex = 0
                    }
                }
            })
        },

        async jumpAdress () {
            const res = await this.$api.address.page({
                patientId: this.patientId,
                page: 1,
                limit: 10
            })
            if (!res.code) {
                if (!res.data.total) {
                    await this.$router.push('/address/create')
                } else {
                    await this.$router.push('/address/list')
                }
            }
        },

        //展示医生或者科室卡片
        showDoctorOrTeam (item) {
            if (item.bindType === 1) {
                this.$api.doctor.getDoctorInfoById(item.doctorId).then(({ code, data }) => {
                    if (!code) {
                        this.doctor = data
                        this.showDoctorDetail = true
                    }
                })
            }
            if (item.bindType === 2) {
                this.$api.doctor.getTeamDetail(item.teamId).then(({ code, data }) => {
                    if (!code) {
                        this.teamDetail = data
                        this.showTeamDetail = true
                    }
                })
            }
        }
    }
}
</script>

<style scoped lang="less">
.my_home {
	padding: 40px 32px;
	.my_info {
		display: flex;
		align-items: center;
		.avatar {
			flex: 0 0 110px;
			> img {
				width: 110px;
				height: 110px;
				border-radius: 50%;
				vertical-align: middle;
			}
		}
		.info {
			flex: auto;
			padding-left: 24px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.user_name {
				height: 48px;
				font-family: PingFangSC-Medium;
				font-size: 40px;
				font-weight: 500;
				line-height: 48px;
				color: #1f2329;
			}
			.action {
				> img {
					width: 11px;
					height: 20px;
				}
			}
		}
	}
	.patient_tab-title {
		padding: 28px 28px 8px 28px;
		color: #1f2329;
		font-size: 32px;
		font-weight: 500;
	}
	.patient_list {
		border-radius: 16px;
		overflow: hidden;
		.base-tab-card {
			height: 56px;
			padding: 0 28px;
			line-height: 56px;
			font-size: 26px;
			border-radius: 28px;
			border: 1px solid @primary;
		}
		.tab-card {
			color: #ffffff;
			background-color: @primary;
		}
		.un-tab-card {
			color: @gray-9;
			border-color: #dee0e3;
		}
		.handle_content {
			padding: 32px 40px;
			text-align: center;
			.list_icon {
				> img {
					width: 54px;
					height: 54px;
				}
			}
			.list_text {
				margin-top: 16px;
				height: 34px;
				font-family: PingFangSC-Regular;
				font-size: 24px;
				font-weight: normal;
				letter-spacing: 0.38px;
				color: #1f2329;
			}
		}
	}
	.menu_list {
		border-radius: 16px;
		overflow: hidden;
		.menu_list_icon {
			width: 40px;
			height: 40px;
			vertical-align: middle;
		}
	}
}
</style>

<style lang="less">
.my_home {
	.patient_list {
		.van-tab {
			padding: 20px 26px 15px;
			.van-tab__text {
				font-family: PingFangSC-Regular;
				font-size: 32px;
				color: #8f959e;
			}
			&.van-tab--active {
				.van-tab__text {
					color: #1f2329;
				}
			}
		}
		.van-tabs__line {
			width: 56px;
			height: 6px;
			border-radius: 2px;
		}
	}
	.menu_list {
		.van-cell {
			padding: 30px 32px;
			align-items: center;
			&::after {
				width: 100%;
			}
			.van-cell__title {
				padding-left: 20px;
				font-family: PingFangSC-Medium;
				font-size: 30px;
				font-weight: 500;
				line-height: 47px;
				color: #1f2329;
			}
		}
	}
}
</style>
